// extracted by mini-css-extract-plugin
export default {"imprintScreenContainer":"ImprintScreen_imprintScreenContainer__Ytr5N","container":"ImprintScreen_container__ET3PB"};